export default class Storage {
    constructor(name) {
        this.name = name;
    }

    /// /////////////////////////////////////
    // -- public

    /**
     * get the local storage object
     *
     * @param {string} value
     * this param is to get a property of the
     * local storage object
     *
     * @return {object|null}
     */
    get(value) {
        const storedData = JSON.parse(localStorage.getItem(this.name));

        if (value && storedData[value]) {
            return storedData[value];
        }

        if (storedData === null) {
            return false;
        }

        return storedData;
    }

    /**
     * sets the local storage object
     *
     * @param {object} value
     * updates the local storage value
     *
     * @return {object}
     */
    set(value) {
        localStorage.setItem(this.name, JSON.stringify(value));

        return this.get(this.name);
    }

    /**
     * removes the local storage item
     */
    remove() {
        localStorage.removeItem(this.name);
    }
}
